@if (pageReady) {
  <main class="gs-page">
    <div class="techerror-container">
      <div class="techerror-headline-container">
        <img [src]="pageLabels.gasSouthLogoSm" alt="Gas South 20 Years Logo" class="logo-image" />
        <div class="techerror-notification">
          <p>
            <i aria-hidden="true" class="techerror-icon fa-solid fa-2x fa-triangle-exclamation"></i>
            <span class="techerror-fontsize">{{ pageLabels.header }}</span>
          </p>
        </div>
        <p class="subheader techerror-fontsize" [innerHTML]="pageLabels.subHeader"></p>
        <h1>{{ pageLabels.returnPageText }}</h1>
      </div>

      <mat-divider></mat-divider>
      <div class="cta-container">
        <button
          role="link"
          mat-flat-button
          color="primary"
          [attr.aria-label]="pageLabels.ctaAriaLabel"
          (click)="goToRedirectPage()"
          class="gs-form-button-primary ok-button"
        >
          {{ pageLabels.ctaLabel }}
        </button>
      </div>
    </div>
  </main>
}
